import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { IDecisionModalProps } from './decisionModalHelper';
import { useSubmitRevision } from 'src/api/commands';
import { useWorkflow } from 'src/hooks/useWorkflow';
import { useSubmissionData } from '../../../contexts/SubmissionDataProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { useState } from 'react';

export const SubmitRevisionModal = ({
  onClose,
  submissionId,
  submissionContextId
}: IDecisionModalProps) => {
  const [showSubmitRevisionSteps, setShowSubmitRevisionSteps] =
    useState<boolean>(false);
  const { articleWorkflow } = useWorkflow();
  const {
    refetchSubmission,
    fieldsResponse: { organizationId }
  } = useSubmissionData();

  const submitRevisionMutation = useSubmitRevision({
    submissionId,
    submissionContextId,
    organizationId,
    articleWorkflowId: articleWorkflow.id,
    invalidateSubmissionQueries: refetchSubmission
  });

  return (
    <>
      {!showSubmitRevisionSteps ? (
        <Modal
          isOpen
          onClose={() => !!submitRevisionMutation.isLoading && onClose}
          width="550px"
          closeButtonProps={{
            hidden: true
          }}
        >
          <Flex padding={8} gap={6} flexDirection="column">
            <Flex>
              <FontAwesomeIcon fontSize={32} icon={faCircleInfo} />
            </Flex>
            <Flex flexDirection="column" gap={2}>
              <Text textStyle="headingGroup">
                Important Note: Review your submission data
              </Text>
              <Text>
                Automatic extraction will not take place. So, as you revise your
                submission, please review the fields carefully since they
                originate from your original submission and make any necessary
                adjustments.
              </Text>
            </Flex>

            <Flex gap={2} justifyContent="flex-end">
              <Button
                isDisabled={submitRevisionMutation.isLoading}
                onClick={onClose}
                variant="secondary"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  setShowSubmitRevisionSteps(true);
                }}
                variant="primary"
              >
                Continue
              </Button>
            </Flex>
          </Flex>
        </Modal>
      ) : (
        null
      )}
    </>
  );
};
